import React from "react";

const SCORE_COLOR_RANGES = [
  { min: 0, max: 9, color: "#ED1717" },
  { min: 10, max: 19, color: "#F24D11" },
  { min: 20, max: 29, color: "#FF9629" },
  { min: 30, max: 39, color: "#FBB806" },
  { min: 40, max: 49, color: "#FFEE00" },
  { min: 50, max: 59, color: "#DDF969" },
  { min: 60, max: 69, color: "#A9F36A" },
  { min: 70, max: 79, color: "#78EC6C" },
  { min: 80, max: 89, color: "#57E86B" },
  { min: 90, max: 100, color: "#3BCE4F" },
];

export const getScoreColor = (score) => {
  const range = SCORE_COLOR_RANGES.find(
    (r) => score >= r.min && score <= r.max,
  );
  return range ? range.color : "#000000";
};

const clampPercentage = (score) => Math.min(Math.max(score, 0), 100);

const ProgressBar = ({ score, trackColor = "#E5E7EB", barColor }) => {
  const percentage = clampPercentage(score);

  const progressBarStyle = {
    width: `${percentage}%`,
    backgroundColor: barColor || getScoreColor(score),
  };

  return (
    <div className="flex items-center gap-3">
      <div
        className="w-full rounded-full h-1 overflow-hidden"
        style={{ backgroundColor: trackColor }}
      >
        <div className="h-1 rounded-full" style={progressBarStyle}></div>
      </div>
      <span className="text-lg font-medium text-gray-900 ">{score}</span>
    </div>
  );
};

export default ProgressBar;
